import { Reducer } from 'redux';
import { UserRole } from "models/UserRole";
import { IRoleActions, RoleActionType } from "redux/actions/RoleActions";

const initialState: UserRole[] | null = null;
export const roleReducer: Reducer<UserRole[] | null, IRoleActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case RoleActionType.FETCH_ROLES_SUCCESS:
                {
                    return action.returnPayload as UserRole[];
                }
            default:
                return state;
        }
    };
